import SpriteSymbol from "../../../hac-ng/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../hac-ng/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow-sync",
  "use": "arrow-sync-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"arrow-sync\"><path d=\"M6 1H1.5S1 1 1 1.5s.498.502.5.5h2.892A7 7 0 008 15v-1.077A5.923 5.923 0 015 2.891v2.615c.004.056.033.495.5.495.5 0 .501-.502.5-.501V1zm4 14v-4.5s0-.502.5-.502.506.5.504.502c0 .756-.001 1.846-.003 2.608A5.923 5.923 0 008 2.078V.999a7 7 0 013.608 13h2.898c.056.004.49.033.49.501 0 .502-.497.5-.496.499H10z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol